export function normalizeYear(year: number | null | undefined): number | undefined {
  if (year === null || year === undefined) return;

  if (year > 0 && year < 70) return 2000 + year;
  if (year >= 70 && year <= 99) return 1900 + year;
  if (year < 1000) {
    return 1000 + year;
  }
  return year;
}
